import { Briefcase, Mail, ArrowUpRight, Building2, Users, MapPinned, LineChart } from 'lucide-react';
import { BRAND_PHOTOS } from '../../lib/brand';
import { INVESTOR_EMAIL } from './landingData';

const HIGHLIGHTS = [
  { icon: Building2, title: '15-restaurant network', text: '10 open, 5 under development with A&W Canada — one of Atlantic Canada\'s fastest-growing franchise groups.' },
  { icon: LineChart, title: '$32M+ run rate', text: 'Projected annual system sales once the development pipeline opens, built on consistent same-store performance.' },
  { icon: Users, title: '220+ team members', text: 'Local hiring, structured training and 5-Star operating standards in every restaurant.' },
  { icon: MapPinned, title: 'Three-province footprint', text: 'Dense coverage in New Brunswick, an established Newfoundland cluster and a first Nova Scotia location in development.' },
];

export const InvestorsSection = () => (
  <section id="investors" className="py-20 sm:py-28 px-6 sm:px-10 bg-[#FDFBF7]" data-testid="investors-section">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-start">
      <div className="lg:col-span-5 lg:sticky lg:top-10">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#F26522] font-semibold mb-4 flex items-center gap-2"><Briefcase className="w-4 h-4" /> Investors</p>
        <h2 className="text-3xl sm:text-4xl font-black text-[#3E2418] tracking-tight leading-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Partnering with a proven operator in a brand Canadians love.
        </h2>
        <p className="text-slate-600 mt-6 leading-relaxed text-base">
          Elmwood Management is a division of Elmwood Capital Limited. Since opening our first A&amp;W in 2023 we have scaled to a multi-unit platform with disciplined operations, strong unit economics and a clear development pipeline.
        </p>
        <a
          href={`mailto:${INVESTOR_EMAIL}?subject=Investor%20inquiry%20%E2%80%94%20Elmwood%20Management`}
          className="mt-8 inline-flex items-center gap-2 bg-[#3E2418] hover:bg-[#5C2E1E] text-white font-semibold rounded-full px-6 py-3 shadow-lg transition-colors btn-press"
          data-testid="investor-contact-btn"
        >
          <Mail className="w-4 h-4" /> Investor inquiries <ArrowUpRight className="w-4 h-4" />
        </a>
        <p className="text-xs text-slate-400 mt-3">{INVESTOR_EMAIL}</p>
      </div>

      <div className="lg:col-span-7 space-y-4">
        <div className="relative rounded-2xl overflow-hidden h-56 sm:h-64 shadow-md group">
          <img src={BRAND_PHOTOS.angle} alt="Elmwood A&W restaurant" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#3E2418]/85 to-transparent" />
          <div className="absolute inset-0 p-6 sm:p-8 flex flex-col justify-end text-white">
            <p className="text-[10px] uppercase tracking-[0.25em] text-orange-300 font-semibold">Development pipeline</p>
            <p className="text-xl sm:text-2xl font-black mt-1" style={{ fontFamily: 'Chivo, sans-serif' }}>Tracadie · Hogan Court · Salisbury · Richibucto · Shediac</p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4 stagger" data-testid="investor-highlights">
          {HIGHLIGHTS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="bg-white border border-orange-100 rounded-2xl p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300">
              <div className="w-10 h-10 rounded-xl bg-orange-50 text-[#F26522] flex items-center justify-center mb-4"><Icon className="w-5 h-5" /></div>
              <h3 className="font-bold text-[#3E2418] text-base" style={{ fontFamily: 'Chivo, sans-serif' }}>{title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
